import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  viewModal: {
    width: 'auto',
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        minWidth: 500,
        maxWidth: 700,
        overflowX: 'hidden',
      },
    },
  },

  successTitle: {
    background: 'green',
    minWidth: 400,
  },
  alertTitle: {
    background: '#e75200',
    minWidth: 400,
  },
  errorTitle: {
    background: 'red',
    minWidth: 400,
  },
  panel: {
    borderTop: `1px solid ${theme.palette.constrastGreyNormal.main}`,
    borderBottom: `1px solid ${theme.palette.constrastGreyNormal.main}`,
    backgroundColor: theme.palette.constrastGreyNormal.main,
  },
  modalContent: {
    wordBreak: 'break-word',
    color: '#000',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: '2px solid lightgrey',
    overflowX: 'hidden',
    minHeight: 75,
  },
  root: {
    height: 'auto',
  },
  button: {
    backgroundColor: 'rgb(62,67,69)',
    textAlign: 'center',
  },
}));

export default styles;
